(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-announcement"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slider = document.querySelector('.fs-announce__slider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.fs-announce__slide');
    if (slides.length < 2) return;
    var speed = parseInt(slider.dataset.speed, 10) * 1000 || 4000;
    var current = 0;

    setInterval(function() {
      slides[current].classList.remove('fs-announce__slide--active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('fs-announce__slide--active');
    }, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-progress"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const bar = document.getElementById('shipping-progress-bar');
    if (!bar) return;
    const threshold = parseInt(bar.dataset.threshold, 10);
    const texts = {
      empty: bar.dataset.emptyText,
      progress: bar.dataset.progressText,
      close: bar.dataset.closeText,
      unlocked: bar.dataset.unlockedText
    };

    function update(totalCents, count) {
      const remaining = Math.max(0, threshold - totalCents);
      const pct = Math.min(100, (totalCents / threshold) * 100);
      const isFree = totalCents >= threshold;
      const isEmpty = count === 0;
      const isClose = pct >= 70 && !isFree && !isEmpty;
      const dollars = Math.ceil(remaining / 100);

      const fill = bar.querySelector('.fs-ship__fill');
      const msg = bar.querySelector('.fs-ship__msg');

      if (fill) {
        fill.style.setProperty('--pct', pct + '%');
        fill.classList.toggle('fs-ship__fill--full', isFree);
        fill.classList.toggle('fs-ship__fill--close', isClose);
      }

      bar.classList.toggle('fs-ship--unlocked', isFree);
      bar.dataset.state = isEmpty ? 'empty' : isFree ? 'unlocked' : isClose ? 'close' : 'progress';

      if (msg) {
        if (isEmpty) {
          msg.textContent = texts.empty;
          msg.className = 'fs-ship__msg';
        } else if (isFree) {
          msg.textContent = texts.unlocked;
          msg.className = 'fs-ship__msg fs-ship__msg--done';
        } else if (isClose) {
          msg.textContent = texts.close.replace('[amount]', dollars);
          msg.className = 'fs-ship__msg fs-ship__msg--close';
        } else {
          msg.textContent = texts.progress.replace('[amount]', dollars);
          msg.className = 'fs-ship__msg';
        }
      }
    }

    document.addEventListener('cart:updated', function(e) {
      if (e.detail) update(e.detail.total_price || 0, e.detail.item_count || 0);
    });

    const origFetch = window.fetch;
    window.fetch = function() {
      return origFetch.apply(this, arguments).then(function(resp) {
        const url = arguments[0]?.url || arguments[0] || '';
        if (typeof url === 'string' && url.includes('/cart') && (url.includes('.js') || url.includes('.json'))) {
          resp.clone().json().then(function(d) {
            if (d && typeof d.total_price !== 'undefined') update(d.total_price, d.item_count || 0);
          }).catch(function(){});
        }
        return resp;
      });
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
